import page404 from "../assets/images/404_page.svg";
import error500 from "../assets/images/500_error.svg";
import aiFox from "../assets/images/AiFox.png";
import app_component_phone from "../assets/images/app_component_phone.png";
import benefit_mark from "../assets/images/benefit_mark.svg";
import camera from "../assets/images/camera.svg";
import camera_small from "../assets/images/camera_small.svg";
import contact_us_girl from "../assets/images/contact_us_girl.svg";
import cow_with_computer from "../assets/images/cow_with_computer.svg";
import cow_with_phone from "../assets/images/cow_with_phone.svg";
import download_app_store from "../assets/images/download_app_store.svg";
import download_google_play from "../assets/images/download_google_play.svg";
import footer_cat from "../assets/images/footer_cat.svg";
import logo from "../assets/images/logo.png";
import logo_us_trademark from "../assets/images/logo_us_trademark.png";
import logo_vegan_active_small from "../assets/images/logo_vegan_active_small.png";
import map_button from "../assets/images/map_button.svg";
import marker from "../assets/images/marker.webp";
import marker_big from "../assets/images/marker_big.webp";
import marker_me from "../assets/images/marker_me.svg";
import newsletter from "../assets/images/newsletter.svg";
import nextButton from "../assets/images/nextButton.svg";
import no_results from "../assets/images/no_results.svg";
import previousButton from "../assets/images/previousButton.svg";
import recipe_chef from "../assets/images/recipe_chef.svg";
import tivoniTaim from "../assets/images/tivoni_taim.svg";
import user_thumbnail from "../assets/images/user_thumbnail.svg";
import vegan_logo_small from "../assets/images/vegan-logo-small.webp";

import company1 from "../assets/images/companies/company1.svg";
import company10 from "../assets/images/companies/company10.svg";
import company11 from "../assets/images/companies/company11.svg";
import company12 from "../assets/images/companies/company12.svg";
import company13 from "../assets/images/companies/company13.svg";
import company14 from "../assets/images/companies/company14.svg";
import company15 from "../assets/images/companies/company15.svg";
import company16 from "../assets/images/companies/company16.svg";
import company17 from "../assets/images/companies/company17.svg";
import company18 from "../assets/images/companies/company18.svg";
import company19 from "../assets/images/companies/company19.svg";
import company2 from "../assets/images/companies/company2.svg";
import company20 from "../assets/images/companies/company20.svg";
import company21 from "../assets/images/companies/company21.svg";
import company22 from "../assets/images/companies/company22.svg";
import company23 from "../assets/images/companies/company23.svg";
import company24 from "../assets/images/companies/company24.svg";
import company25 from "../assets/images/companies/company25.svg";
import company26 from "../assets/images/companies/company26.svg";
import company27 from "../assets/images/companies/company27.svg";
import company28 from "../assets/images/companies/company28.svg";
import company3 from "../assets/images/companies/company3.svg";
import company4 from "../assets/images/companies/company4.svg";
import company5 from "../assets/images/companies/company5.svg";
import company6 from "../assets/images/companies/company6.svg";
import company7 from "../assets/images/companies/company7.svg";
import company8 from "../assets/images/companies/company8.svg";
import company9 from "../assets/images/companies/company9.svg";

import avatar1 from "../assets/images/avatars/avatar_1.webp";
import avatar2 from "../assets/images/avatars/avatar_2.webp";
import avatar3 from "../assets/images/avatars/avatar_3.webp";
import avatar4 from "../assets/images/avatars/avatar_4.webp";
import avatar5 from "../assets/images/avatars/avatar_5.webp";
import avatar6 from "../assets/images/avatars/avatar_6.webp";
import avatar7 from "../assets/images/avatars/avatar_7.webp";
import avatar8 from "../assets/images/avatars/avatar_8.webp";
import avatar9 from "../assets/images/avatars/avatar_9.webp";

import banner_about from "../assets/images/banner/banner_about.png";
import banner_benefit from "../assets/images/banner/banner_benefit.png";
import banner_suitcase from "../assets/images/banner/banner_suitcase.svg";
import benefit_placeholder from "../assets/images/benefit_placeholder.png";
import default_entity_logo from "../assets/images/default_entity_logo.png";
import default_restaurant_cover from "../assets/images/default_restaurant_cover.png";
import menu_placeholder from "../assets/images/menu_placeholder.png";
import news_cover from "../assets/images/news_cover.png";
import reviews_empty_placeholder from "../assets/images/reviews_empty_placeholder.png";
import vegan_friendly_white from "../assets/images/vegan_friendly_white.svg";

import about_green_arrow from "../assets/images/about_us/about_green_arrow.svg";

import about_label_product_il from "../assets/images/about_us/about_label_product_il.png";
import about_label_restaurants_il from "../assets/images/about_us/about_label_restaurants_il.png";

import about_label_businesses_us from "../assets/images/about_us/about_label_businesses_us.webp";
import about_label_product_us from "../assets/images/about_us/about_label_product_us.webp";
import about_label_restaurants_us from "../assets/images/about_us/about_label_restaurants_us.png";

import about_label_businesses_uk from "../assets/images/about_us/about_label_businesses_uk.webp";
import about_label_product_uk from "../assets/images/about_us/about_label_product_uk.png";
import about_label_restaurants_uk from "../assets/images/about_us/about_label_restaurants_uk.png";
import dotted_bg from "../assets/images/bg_dotted.png";
import empty_vf_icon from "../assets/images/Empty.png";
import leaf from "../assets/images/leaf.png";
import alpro from "../assets/images/trademark/product/alpro.png";
import hellman from "../assets/images/trademark/product/hellman.png";
import ilmakiaje from "../assets/images/trademark/product/ilmakiage.png";
import Knorr_Logo_2020 from "../assets/images/trademark/product/Knorr_Logo_2020.svg.png";
import lindt from "../assets/images/trademark/product/lindt.png";
import loaker from "../assets/images/trademark/product/loaker.jpeg";
import lotus from "../assets/images/trademark/product/lotus.png";
import Magnum from "../assets/images/trademark/product/Magnum.png";
import oreo from "../assets/images/trademark/product/oreo.png";
import Ritter_Sport_logo from "../assets/images/trademark/product/Ritter_Sport_logo.svg.png";
import strauss from "../assets/images/trademark/product/strauss.jpeg";
import unilever from "../assets/images/trademark/product/unilever.png";
import violife from "../assets/images/trademark/product/violife.png";
import weleda from "../assets/images/trademark/product/weleda.jpeg";
import yoegg from "../assets/images/trademark/product/yoegg.jpeg";

import business_survey from "../assets/images/business_survey.png";
import submit_cat from "../assets/images/submit_cat.png";
import bagelfactory from "../assets/images/trademark/business/bagelfactory.png";
import crocs from "../assets/images/trademark/business/crocs.png";
import dominos from "../assets/images/trademark/business/dominos.png";
import hp from "../assets/images/trademark/business/hp.png";
import palladium from "../assets/images/trademark/business/palladium.png";
import teva from "../assets/images/trademark/business/teva.png";
import toms from "../assets/images/trademark/business/toms.png";

import bake from "../assets/images/trademark/business/types/bake.png";
import cafe from "../assets/images/trademark/business/types/cafe2.png";
import cater from "../assets/images/trademark/business/types/cater.png";
import clothing from "../assets/images/trademark/business/types/clothing.png";
import gift from "../assets/images/trademark/business/types/gift.png";
import hotels from "../assets/images/trademark/business/types/hotels.png";
import ice from "../assets/images/trademark/business/types/ice.png";
import pizza from "../assets/images/trademark/business/types/pizza.png";

import bevereage from "../assets/images/trademark/business/types/beverage.png";
import cosmetics from "../assets/images/trademark/business/types/cosmetics2.png";
import food from "../assets/images/trademark/business/types/food.png";
import ready from "../assets/images/trademark/business/types/ready.png";
import soaps from "../assets/images/trademark/business/types/soaps.png";
import spices from "../assets/images/trademark/business/types/spices.png";
import vitamins from "../assets/images/trademark/business/types/vitamins.png";

import business_hero from "../assets/images/trademark_business_hero.png";
import general_hero from "../assets/images/trademark_general_hero.png";

import building from "../assets/images/trademark/general/building.png";
import chips from "../assets/images/trademark/general/chips.png";
import table from "../assets/images/trademark/general/table.png";

import boorekas from "../assets/images/trademark/general/boorekas.png";
import clothing_on_hanger from "../assets/images/trademark/general/clothing.png";
import drops from "../assets/images/trademark/general/drops.png";

import confetti from "../assets/images/trademark/confetti.svg";
import flow_chart_arrow from "../assets/images/trademark/flow_chart_arrow.svg";
import flow_chart_arrow_mobile from "../assets/images/trademark/flow_chart_arrow_mobile.svg";
import flow_chart_down_arrow from "../assets/images/trademark/flow_chart_down_arrow.svg";
import flow_chart_last from "../assets/images/trademark/flow_chart_last.svg";

export default {
  confetti,
  flowChartDownArrow: flow_chart_down_arrow,
  flowChartArrowMobile: flow_chart_arrow_mobile,
  bannerSuitcase: banner_suitcase,
  bannerBenefit: banner_benefit,
  bannerAbout: banner_about,
  appComponentPhone: app_component_phone,
  logoVeganActiveSmall: logo_vegan_active_small,
  veganLogoSmall: vegan_logo_small,
  mapMarker: marker,
  mapMarkerBig: marker_big,
  mapMarkerMe: marker_me,
  footerCat: footer_cat,
  recipeChef: recipe_chef,
  downloadAppStore: download_app_store,
  downloadGooglePlay: download_google_play,
  newsletter: newsletter,
  tivoniTaim: tivoniTaim,
  galleryPreviousButton: previousButton,
  galleryNextButton: nextButton,
  aboutLabelProductUS: about_label_product_us,
  aboutLabelRestaurantUS: about_label_restaurants_us,
  aboutLabelRestaurantIL: about_label_restaurants_il,
  aboutLabelProductIL: about_label_product_il,
  aboutLabelBusinessesUS: about_label_businesses_us,
  aboutLabelProductUK: about_label_product_uk,
  aboutLabelRestaurantUK: about_label_restaurants_uk,
  aboutLabelBusinessesUK: about_label_businesses_uk,
  aboutGreenArrow: about_green_arrow,
  mapButton: map_button,
  contactUsGirl: contact_us_girl,
  benefitMark: benefit_mark,
  noResults: no_results,
  userThumbnail: user_thumbnail,
  cowWithComputer: cow_with_computer,
  aiFox: aiFox,
  cowWithPhone: cow_with_phone,
  camera: camera,
  cameraSmall: camera_small,
  newsCover: news_cover,
  page404: page404,
  error500: error500,
  company1: company1,
  company2: company2,
  company3: company3,
  company4: company4,
  company5: company5,
  company6: company6,
  company7: company7,
  company8: company8,
  company9: company9,
  company10: company10,
  company11: company11,
  company12: company12,
  company13: company13,
  company14: company14,
  company15: company15,
  company16: company16,
  company17: company17,
  company18: company18,
  company19: company19,
  company20: company20,
  company21: company21,
  company22: company22,
  company23: company23,
  company24: company24,
  company25: company25,
  company26: company26,
  company27: company27,
  company28: company28,
  avatar1: avatar1,
  avatar2: avatar2,
  avatar3: avatar3,
  avatar4: avatar4,
  avatar5: avatar5,
  avatar6: avatar6,
  avatar7: avatar7,
  avatar8: avatar8,
  avatar9: avatar9,
  defaultRestaurantCover: default_restaurant_cover,
  defaultEntityLogo: default_entity_logo,
  reviewsEmptyPlaceholder: reviews_empty_placeholder,
  veganFriendlyWhite: vegan_friendly_white,
  menuPlaceholder: menu_placeholder,
  benefitPlaceholder: benefit_placeholder,
  dottedBackground: dotted_bg,
  leaf,
  flowChartArrow: flow_chart_arrow,
  flowChartLast: flow_chart_last,
  emptyVfIcon: empty_vf_icon,
  submitCat: submit_cat,
  businessSurvey: business_survey,
  logo_us_trademark,
  logo,
  trademarks: {
    building,
    chips,
    table,
    boorekas,
    drops,
    clothing: clothing_on_hanger,
    generalHero: general_hero,
    businessHero: business_hero,
    business_types: {
      cater,
      gift,
      clothing,
      cafe,
      bake,
      ice,
      pizza,
      hotels,
    },
    product_types: {
      food,
      bevereage,
      vitamins,
      cosmetics,
      soaps,
      ready,
      spices,
    },
    product: [
      alpro,
      hellman,
      ilmakiaje,
      Knorr_Logo_2020,
      lindt,
      loaker,
      lotus,
      Magnum,
      oreo,
      Ritter_Sport_logo,
      strauss,
      unilever,
      violife,
      weleda,
      yoegg,
    ],
    business: [bagelfactory, crocs, dominos, hp, palladium, teva, toms],
    general: [
      crocs,
      dominos,
      hellman,
      Knorr_Logo_2020,
      loaker,
      Magnum,
      oreo,
      bagelfactory,
      weleda,
    ],
  },
};

export const imagesAlts = {
  bannerSuitcase: "Small orange suitcase",
  appComponentPhone:
    "a phone presenting the Vegan Friendly application and restaurant benefits that are redeemable through it",
  logoVeganActiveSmall: "small Vegan Active logo",
  veganLogoSmall: "small vegan friendly logo",
  mapMarker:
    'small heart shaped radish (vegan friendly logo without the "Vegan friendly" written inside the radish)',
  mapMarkerBig: "small vegan friendly logo",
  mapMarkerMe: "green location dot that marks your location",
  footerCat: "cute cat peeking behing a computer screen",
  recipeChef:
    "cute smiling chef with a chef hat cooking something on a pot with kitchen instruments around him",
  downloadAppStore:
    'black button that says "download on the app store" with an apple logo',
  downloadGooglePlay:
    'black button that says "get it on google play" with the google play logo',
  newsletter: "a small baby chick winking placed inside an open envelope",
  tivoniTaim: 'logo of the "tivoni taim" group inside an animated hamburger',
  galleryPreviousButton: "grey arrow pointing to the left",
  galleryNextButton: "grey arrow pointing to the right",
  aboutLabelProduct:
    "mock minced meat product with the vegan friendly logo on the package",
  aboutLabelRestaurant:
    "A restaurant front window with the vegan friendly sticker on it",
  aboutLabelBusinesses:
    "white sneaker with a vegan friendly tag attached to it",
  aboutGreenArrow: "small green arrow pointing to the right",
  mapButton: 'a map icon that says "map"',
  contactUsGirl:
    "a smiling telemarketer wearing headphones, working on her laptop with a coffee mug and a plant on her side",
  benefitMark: "pink badge",
  noResults: "small yellow chick peeking out of an egg",
  userThumbnail: "small animated icon of a person",
  cowWithComputer: "hamster with a sunflower seed",
  cowWithPhone: "cow with a cellphone",
  camera: "camera icon",
  cameraSmall: "small camera icon",
  page404:
    "the number 404 in stylized graphics, where the zero is replaced by a surprised cow",
  error500: "yellow triangle with ! inside",
  company1: "company1",
  company2: "company2",
  company3: "company3",
  company4: "company4",
  company5: "company5",
  company6: "company6",
  company7: "company7",
  company8: "company8",
  company9: "company9",
  company10: "company10",
  company11: "company11",
  company12: "company12",
  company13: "company13",
  company14: "company14",
  company15: "company15",
  company16: "company16",
  company17: "company17",
  company18: "company18",
  company19: "company19",
  company20: "company20",
  company21: "company21",
  company22: "company22",
  company23: "company23",
  company24: "company24",
  company25: "company25",
  company26: "company26",
  company27: "company27",
  company28: "company28",
  avatar1: "radish making a kiss face",
  avatar2: "cute broccoli",
  avatar3: "smiling red chili pepper",
  avatar4: "cute carrot",
  avatar5: "cute tomato",
  avatar6: "cute eggplant",
  avatar7: "smiling pickle",
  avatar8: "cute pear",
  avatar9: "smiling orange",
  defaultRestaurantCover: "default restaurant cover",
  defaultEntityLogo: "Default entity logo - vegan friendly logo",
  reviewsEmptyPlaceholder: "Empty reviews list place holder",
  veganFriendlyWhite: "Vegan friendly logo in white",
  menuPlaceholder: "Tomato image",
  benefitPlaceholder: "Gift image",
};
